<template>
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="180px"
        label-position="left"
        class="webhook-form"
    >
        <fieldset class="mb-4">
            <legend>{{ $l10n.__('Configurer le webhook') }}</legend>
            <slot name="endpoint"></slot>
        </fieldset>
        <slot name="format"></slot>
        <fieldset>
            <legend>{{ $l10n.__('Configurer les notifications envoyées au webhook') }}</legend>
            <slot name="configDescription"></slot>
            <slot name="configuration">
                <el-tabs tab-position="left" type="card" class="webhooks-tabs mt-4">
                    <el-tab-pane v-for="log in parentLogs" :key="log.id" :label="log.description">
                        <template #label>
                            <div class="flex-level">
                                <span class="mr-2">{{ log.description }}</span>
                                <el-tag
                                    effect="dark"
                                    type="warning"
                                    size="mini"
                                    class="flex-item-right"
                                >
                                    <slot name="tagEvents" :currentLog="log"></slot>
                                </el-tag>
                            </div>
                        </template>
                        <!-- Content of right tab -->
                        <slot name="events" :log="log"></slot>
                    </el-tab-pane>
                </el-tabs>
            </slot>
        </fieldset>
        <div class="margin-modal">
            <CompassButton
                :label="$t.__('common.actions.cancel')"
                type="secondary"
                @click="closeModal"
            />
            <CompassButton
                :label="$t.__('common.actions.save')"
                type="primary"
                @click="submit"
                class="ml-2"
            />
        </div>
    </el-form>
</template>

<script>
export default {
    props: {
        logs: {
            type: Array,
            required: false,
        },
        form: {
            type: Object,
            required: true,
            default: () => {},
        },
        rules: {
            type: Object,
            required: true,
            default: () => {},
        },
    },
    methods: {
        closeModal() {
            EventBus.emit('webhook:close');
        },
        submit() {
            this.$refs['form'].validate((valid) => {
                if (!valid) {
                    document.querySelector('.el-dialog__wrapper').scrollTo({
                        top: document.querySelector('.el-form-item,.is-error').offsetTop,
                        behavior: 'smooth',
                    });
                    return false;
                }
                this.$emit('submit');
            });
        },
    },
    computed: {
        parentLogs() {
            return this.logs.filter((log) => _.isNil(log.parent));
        },
    },
};
</script>
<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.webhooks-tabs {
    .el-tabs__item {
        line-height: 40px;
        padding-bottom: 0;

        &.is-active {
            background-color: $primary;
            color: $white;
        }
    }

    .el-tabs__nav-scroll {
        overflow: auto !important;
    }

    .el-tabs__nav-prev,
    .el-tabs__nav-next {
        display: none;
    }

    .el-tabs__nav-wrap {
        padding: 0 !important;
    }

    &.el-tabs {
        .el-tabs__nav-scroll,
        .el-tabs__nav-wrap.is-left,
        .el-tabs__header.is-left {
            height: auto;
        }
    }
}

.webhook-form {
    .el-form-item__label {
        line-height: 32px;
    }
    .margin-modal {
        display: flex;
        justify-content: flex-end;
        gap: 16px;
        padding-top: 24px;
    }
}
</style>
